import React from 'react';
import {
  Alert,
  AlertTitle,
  CircularProgress,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { Close, CheckCircleOutline, ErrorOutline } from '@mui/icons-material';

export interface CreateResponseStatusProps {
  loading: boolean;
  open: boolean;
  creatingResponse: boolean;
  creatingResponseError: boolean;
  attachments: { pending: number; created: number; failed: number };
  close: Function;
}

export const CreateResponseStatus = ({
  loading,
  open,
  creatingResponse,
  creatingResponseError,
  attachments,
  close,
}: CreateResponseStatusProps) => {
  const content = (
    <Alert
      variant="filled"
      severity="success"
      sx={
        attachments.failed > 0 || creatingResponseError
          ? { backgroundColor: 'warning.main' }
          : { backgroundColor: 'secondary.main' }
      }
      icon={
        loading ? (
          <CircularProgress color="inherit" size={22} />
        ) : creatingResponseError ? (
          <ErrorOutline fontSize="inherit" />
        ) : (
          <CheckCircleOutline fontSize="inherit" />
        )
      }
      action={
        loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    >
      <AlertTitle>
        <Typography variant="h6">
          {creatingResponse
            ? 'Creating Response...'
            : attachments.failed > 0 && !creatingResponseError
            ? 'Created Response with Errors'
            : creatingResponseError
            ? 'Error Creating Response'
            : 'Created Response'}
        </Typography>
      </AlertTitle>
      <Typography variant="subtitle2">
        The response was created successfully
      </Typography>
      {attachments.created + attachments.pending + attachments.failed > 0 && (
        <Typography variant="subtitle2">
          {attachments.pending > 0 ? 'Uploading' : 'Uploaded'} Response
          Attachments: {attachments.created}/
          {attachments.created + attachments.pending + attachments.failed}{' '}
          succeeded &nbsp;&nbsp;&nbsp;{' '}
          {attachments.failed > 0 && `${attachments.failed} FAILED!`}
        </Typography>
      )}
    </Alert>
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={!loading ? 3000 : null}
      onClose={() => close()}
      message={content}
      open={open}
      ContentProps={{
        sx:
          attachments.failed > 0 || creatingResponseError
            ? { backgroundColor: 'warning.main' }
            : { backgroundColor: 'secondary.main' },
      }}
      action={
        !loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    />
  );
};
